enum TimespanUnit {
  Year = 'year',
  Month = 'month',
  Day = 'day',
}
export default TimespanUnit;
